var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-list',{ref:"disclosure-template-list",attrs:{"name":"disclosure-templates","clickable":true},on:{"rowClicked":_vm.showDetail},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('esg-base-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.showNew}},[_vm._v("생성\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }